import PropTypes from 'prop-types';
import React from 'react';

import CheckCustomerCard from '../../../common/CheckCustomerCard';
import Switch from '../../../common/Switch';

const AutoChargeRecurring = ({ checked, disabled, onChange, customer }) => (
  <div className="layout__item u-2/3-medium-and-up u-pl0 u-mt--">
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      label="Autocharge recurring appointments"
    />
    <CheckCustomerCard display-if={checked} customer={customer} />
  </div>
);

AutoChargeRecurring.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  customer: PropTypes.object.isRequired, // eslint-disable-line
};

AutoChargeRecurring.defaultProps = {
  disabled: false,
}

export default AutoChargeRecurring;
